export default __webpack_public_path__ + "static/media/delete.91abbd6c.png";